/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MyGooseGamePlayerQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MyGooseGamePlayerQuery = {
  myGooseGamePlayer: Pick<
    Types.GooseGamePlayer,
    | "id"
    | "event_attendee_id"
    | "current_points"
    | "total_points"
    | "created_at"
    | "dashboard_last_viewed_at"
  >;
};

export const MyGooseGamePlayerDocument = gql`
  query MyGooseGamePlayer {
    myGooseGamePlayer {
      id
      event_attendee_id
      current_points
      total_points
      created_at
      dashboard_last_viewed_at
    }
  }
`;

/**
 * __useMyGooseGamePlayerQuery__
 *
 * To run a query within a React component, call `useMyGooseGamePlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGooseGamePlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGooseGamePlayerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGooseGamePlayerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MyGooseGamePlayerQuery,
    MyGooseGamePlayerQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    MyGooseGamePlayerQuery,
    MyGooseGamePlayerQueryVariables
  >(MyGooseGamePlayerDocument, baseOptions);
}
export function useMyGooseGamePlayerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MyGooseGamePlayerQuery,
    MyGooseGamePlayerQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    MyGooseGamePlayerQuery,
    MyGooseGamePlayerQueryVariables
  >(MyGooseGamePlayerDocument, baseOptions);
}
export type MyGooseGamePlayerQueryHookResult = ReturnType<
  typeof useMyGooseGamePlayerQuery
>;
export type MyGooseGamePlayerLazyQueryHookResult = ReturnType<
  typeof useMyGooseGamePlayerLazyQuery
>;
export type MyGooseGamePlayerQueryResult = ApolloReactCommon.QueryResult<
  MyGooseGamePlayerQuery,
  MyGooseGamePlayerQueryVariables
>;
